import { useEffect, memo } from "react";
import { useAppContext } from "../Context/AppContext";

const SESSION_EXPIRED_EVENT = "sessionExpired";

function SessionHandler() {
  const { setSessionExpired } = useAppContext();

  useEffect(() => {
    const handler = () => setSessionExpired(true);
    window.addEventListener(SESSION_EXPIRED_EVENT, handler);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
  }, [setSessionExpired]);

  return null;
}

SessionHandler.displayName = "SessionHandler";

export default memo(SessionHandler);
